var ajaxCity;
var ajaxSingleValidate;
var ajaxRelationValidate;
var ajaxGradeValidate;
var ajaxAllValidate;
var ajaxPostal1;
var ajaxPostal2;
/**
 * 体験授業申込みフォームアクションを登録する
 */
function trialFormAction() {

	// 対象校舎の選択を変更したときの挙動
	$('.js-chk-kousha').on('change', function() {
		const koushaId = $(this).val();

		// 曜日の有効/無効を切り替える
		toggleDayList(koushaId, $(this).is(':checked'));

		// 曜日箇所のエラー文言を出し分け
		toggleDayListErrorText(koushaId, $(this).is(':checked'));

		// 体験を希望する教室にチェックが入っていない場合のエラーメッセージ
		ajaxHopeDayCheck();

		// 学年チェック
		ajaxGradeCheck();

		confirmButtonDisplay();
	});

	// 全角半角変換
	$(".js-characters-change").on('change', function(e){
		var txt = $(this).val();
		var han = txt.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
		han = han.replace(/[━.*‐.*―.*－.*\–.*ー.*\-]/gi,'');
		$(this).val(han);
	});

	// ライブバリデート
	$('.js-trial-ajax-check').on('blur', function() {
		
		var target = $(this);
		var key = $(this).attr('name');
		var value = $(this).val();
		
		// nameのtrial[]の文言を除去
		key = key.replace('trial[', '');
		key = key.replace(']', '');
		
		// ラジオボタンの場合は選択されている値を取得
		if ($(target).attr('type') == 'radio') {
			value = $('input[name=\'' + $(this).attr('name') + '\']:checked').val();
			if (value == undefined) {
				value = '';
			}
		}
		
		ajaxCheck(target, key, value);
	});
	
	// ライブバリデート続柄
	$('.js-trial-ajax-relationcheck-text').on('blur', function() {
		ajaxRelationCheck();
	});
	$('.js-trial-ajax-relationcheck-checkbox').on('change', function() {
		ajaxRelationCheck();
	});
	// 続柄 その他項目の出し分け
	$('.js-register_cd-toggle-etc').on('change', function() {
		toggleRegisterEtc();
	});
	
	// ライブバリデート学年
	$('.js-trial-ajax-gradecheck').on('blur', function() {
		ajaxGradeCheck();
	});
	
	// ライブバリデート電話番号
	$('.js-trial-ajax-telcheck').on('blur', function() {
		if ($("#tel1").val() == "" || $("#tel2").val() == "" || $("#tel3").val() == "" || $(".tel1_err").children().length > 1 || $(".tel2_err").children().length > 1 || $(".tel3_err").children().length > 1 ) {
			$(".tel_err").children('p.inq-form-err').each(function() {$(this).remove();});
			$("#tel").removeClass("trialForm-error");
			var key = $(this).attr('name');
			key = key.replace('trial[', '');
			key = key.replace(']', '');
			ajaxCheck($(this), key, $(this).val());
		} else {
			key = 'tel';
			value = $("#tel1").val() + $("#tel2").val() + $("#tel3").val();
			target = $("#tel").get(0);
			ajaxCheck(target, key, value);
		}
	});
	
	// ライブバリデート体験授業希望曜日
	$('.js-trial-ajax-choiceddatecheck').on('click', function() {
		ajaxHopeDayCheck();
		confirmButtonDisplay();
	});
	
	//都道府県プルダウン選択時のイベント
	$('#pref_cd').change(function(){
		//市区町村プルダウンの選択を初期化
		$('#s_place_cd option').remove();
		$('#s_place_cd optgroup').remove();
		$('#s_place_cd').append($('<option>').html("市区町村を選択").val(""));
		
		//ajaxで市区町村リスト取得
		ajaxCity = $.ajax({
			type: "POST",
			url: "/city/get_combo_list_by_pref/"+$('#pref_cd').val()+"/",
			data: { is_json: 1}
		}).done(function( res ) {
			//市区町村プルダウンの選択を初期化
			$('#s_place_cd option').remove();
			$('#s_place_cd optgroup').remove();
			$('#s_place_cd').append($('<option>').html("市区町村を選択").val(""));
			for(var i in res.list){
				//市区町村項目を追加
				$('#s_place_cd').append($('<option id="' + res.list[i].City.s_place_cd + '">').html(res.list[i].City.s_place_name).val(res.list[i].City.s_place_cd));
			}
			//都道府県選択時にajaxで市区町村リスト更新後にchangeイベント発火
			$('[name="trial[s_place_cd]"]').trigger('change');
		});
		
	});
	
	// 郵便番号入力時
	$('.js-post').keyup(function() {
		var postal = $("#postal").val().replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
		if(postal.length == 7) {
			getAddressForPostal(postal);
		}
	});
	
	// フォーカス時
	$('.js-trial-ajax-check,.js-trial-ajax-gradecheck,.js-trial-ajax-telcheck,.js-trial-ajax-relationcheck-text,.js-trial-ajax-choiceddatecheck,.js-chk-kousha').on('focus', function() {
		deleteErrorMessage($(this));
	});
	
	// 性別選択時
	$("input[name='trial[sex]']").click(function(e) {
		// エラー削除
		clearSexError();
	});
	
	// iPad対応
	if (navigator.userAgent.indexOf('iPad') > 0) {
		// 性別選択時
		$("input[name='trial[sex]']").click(function(e) {
			// エラー削除
			$("#sex_td").removeClass('trialForm-error');
			$('.sex_err').html('');
		});
	}
	
	// 残り項目ボタン押下時
	$('.js-error-scroll').click(function(e){
		var data = $("form").serializeArray();
		ajaxAllValidate = $.ajax({
			type:'POST',
			url:"/trial/ajax_validate_all/",
			data: { is_json: 1, 'validate_data':data}
		}).done(function( res ) {
			if (res.data != undefined) {
				var className = "";
				$.each(res.errors, function(i, val) { 
					className = i.replace("trial_ajax_form.","");
					if (className == 'hope_day') {
						// 体験授業希望曜日にエラーがある場合、エラーメッセージ表示
						showErrorHopeDay(res.errors["trial_ajax_form.hope_day"]);
				 	} else if ($("."+className+"_err").text() == "") {
						if (className == 'sex') {
							$("#"+className+"_td").addClass("trialForm-error");
							$("."+className+"_err").append('<p class="inq-form-err" >' + val + "</p>");
						} else {
							$("#"+className).addClass("trialForm-error");
							$("."+className+"_err").append('<p class="inq-form-err" >' + val + "</p>");
						}
					}
				})
			}
			
			var anchor = $("#anchor").val();
			if (anchor == '' || anchor == 'undefined') {
				return;
			}
			var p = $('#' + anchor).offset().top;
			$('html,body').animate({ scrollTop: p }, 'fast');
		});
	});
	
	var confirmSubmit = 0;
	// 確認画面ボタン押下時
	$('.js-confirm-submit').click(function(e){
		if (confirmSubmit==0) {
			confirmSubmit = 1;

			// 1つもチェックがついてない場合はエラーとする。
			checkKousha = $('[name="chk_kousha[]"]:checked').map(function(){return $(this).val();}).get().join(',');
			if (checkKousha == '') {
				alert("教室を最低一つ選択してください");
				confirmSubmit = 0;
				return ;
			}
			$('input').each(function(){
				var val = $(this).val();
				var placeholder = $(this).attr('placeholder');
				if (val == placeholder) {
					$(this).val('');
				}
			});
			if (ajaxCity) {
				ajaxCity.abort();
			}
			if (ajaxSingleValidate) {
				ajaxSingleValidate.abort();
			}
			if (ajaxRelationValidate) {
				ajaxRelationValidate.abort();
			}
			if (ajaxGradeValidate) {
				ajaxGradeValidate.abort();
			}
			if (ajaxAllValidate) {
				ajaxAllValidate.abort();
			}
			if (ajaxPostal1) {
				ajaxPostal1.abort();
			}
			if (ajaxPostal2) {
				ajaxPostal2.abort();
			}
			document.form1.submit();
			return true;
		} else {
			return false;
		}
	});
	
	/** 住所検索機能 */
	$('.js-post-search').on('click', function() {
		ipop();
	});
	
	// 住所検索機能のメソッドをオーバーライドする。郵便番号、住所をセット
	$(document).on('click', '.add_select', function(){
		zipCd = $(this).attr('rel');
		$('#postal').val(zipCd);
		$('#postal').removeClass('trialForm-error');
		getAddressForPostal(zipCd);
		$('#ipop_close').click();
	});
	
	$(document).ready(
			// カナ自動入力
			function() {			 
				$.fn.autoKana('#name1', '#kana1', {
					katakana : false//true：カタカナ、false：ひらがな（デフォルト）
			});
				$.fn.autoKana('#name2', '#kana2', {
					katakana : false//true：カタカナ、false：ひらがな（デフォルト）
			});

			// エラーがある場合
			if ($("#tutor_area").val() != '') {
//				alert('資料を希望する塾・家庭教師を再度ご確認ください');
			} else if ($("#error_count").val() > 0) {
				alert('未入力項目が' + $("#error_count").val() + '個あります');
			} else {
				$('#register_cd_td','input[value="001"]').focus();
			}
			confirmButtonDisplay();
			if ($("#error_count").val() > 0) {
				var anchor = $("#anchor").val();
				var p = $('#' + anchor).offset().top;
				$('html,body').animate({ scrollTop: p }, 'fast');
			}
		});

	//ローカルストレージから入力項目復元
	setRestoreFormValue();
}

/**
 * エラー文言を削除する
 * @param {object} target - バリデーション対象のjQueryオブジェクト
 */
function deleteErrorMessage(target) {
	
	let key = target.attr('name');
	key = key.replace('trial[', '');
	key = key.replace(']', '');
	$("." + key + "_err").children('p.inq-form-err').each(function() {$(this).remove();});
	
	// エラーの背景変更
	target.removeClass("trialForm-error");
}

/**
 * 入力項目のバリデーションを実行する
 */
function ajaxCheck(target, key, value) {

	ajaxSingleValidate = $.ajax({
		type:'POST',
		url:"/trial/ajax_validate/",
		scriptCharset:"UTF-8",
		data: { is_json: 1, key:key, value:value}
	}).done(function( res ) {
		// エラー文言削除
		$("." + key + "_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.data != undefined) {
			// チェックエラーがある場合はエラーを表示
			$("." + key + "_err").append(res.data);
			
			// 背景を変更する時ラジオボタンの場合は親要素のtdにclass追加
			if ($(target).attr('type') == 'radio') {
				$(target).parents('td').addClass("trialForm-error");
			} else {
				$(target).addClass("trialForm-error");
			}
			confirmButtonDisplay();
		} else {
			// 背景を変更する時ラジオボタンの場合は親要素のtdからclass削除
			if ($(target).attr('type') == 'radio') {
				$(target).parents('td').removeClass("trialForm-error");
			} else {
				$(target).removeClass("trialForm-error");
			}
			confirmButtonDisplay();
		}
	});
}

/**
 * 続柄のバリデーションを実行する
 */
function ajaxRelationCheck() {
	var data = $("form").serializeArray();
	
	ajaxRelationValidate = $.ajax({
		type:'POST',
		url:"/trial/ajax_validate_relation/",
		scriptCharset:"UTF-8",
		data: { is_json: 1,'validate_data':data}
	}).done(function( res ) {
		
		// 続柄チェック
		$(".register_cd_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".register_etc_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.errors != undefined && res.errors['trial_form_relation.register_cd'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if ($.isArray(res.errors['trial_form_relation.register_cd']) ) {
				message = res.errors['trial_form_relation.register_cd'][0];
			} else {
				message = res.errors['trial_form_relation.register_cd'];
			}
			$(".register_cd_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			$('[name="trial[register_cd]"]').addClass("trialForm-error");
			confirmButtonDisplay();
		} else if (res.errors != undefined && res.errors['trial_form_relation.register_etc'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if ($.isArray(res.errors['trial_form_relation.register_etc']) ) {
				message = res.errors['trial_form_relation.register_etc'][0];
			} else {
				message = res.errors['trial_form_relation.register_etc'];
			}
			$(".register_etc_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			$('[name="trial[register_etc]"]').addClass("trialForm-error");
			confirmButtonDisplay();
		} else {
			$('[name="trial[register_cd]"]').removeClass("trialForm-error");
			$('[name="trial[register_etc]"]').removeClass("trialForm-error");
			confirmButtonDisplay();
		}
		
		// 続柄、学年相関チェック
		if ($('#grade').val() != '') {
			$(".grade_err").children('p.inq-form-err').each(function() {$(this).remove();});
			if (res.errors != undefined && res.errors['trial_form_relation.grade'] != undefined) {
				// チェックエラーがある場合はエラーを表示
				message = '';
				if ($.isArray(res.errors['trial_form_relation.grade']) ) {
					message = res.errors['trial_form_relation.grade'][0];
				} else {
					message = res.errors['trial_form_relation.grade'];
				}
				$(".grade_err").append('<p class="inq-form-err" >' + message + "</p>");
				
				$("#grade").removeClass("trialForm-error");
				$("#grade").addClass("trialForm-error");
				confirmButtonDisplay();
			} else {
				$("#grade").removeClass("trialForm-error");
				confirmButtonDisplay();
			}
		}
	});
}

/**
 * 性別 エラー解除
 */
function clearSexError() {
	// エラー削除
	$('[name="trial[sex]"]').removeClass('trialForm-error');
	$('.sex_err').html('');
}

/**
 * 続柄 その他項目の出し分け
 */
function toggleRegisterEtc() {
	let registerCdValue = $('[name="trial[register_cd]"]:checked').val();
	if (registerCdValue == '006') {
		$('.js-register_etc-toggle').show();
	} else {
		$('.js-register_etc-toggle').hide();
	}
}

/**
 * 学年のバリデーションを実行する
 */
function ajaxGradeCheck() {
	var data = $("form").serializeArray();
	
	ajaxGradeValidate = $.ajax({
		type:'POST',
		url:"/trial/ajax_validate_grade/",
		scriptCharset:"UTF-8",
		data: { is_json: 1,'validate_data':data}
	}).done(function( res ) {
		
		// エラー文言削除
		$(".grade_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.errors != undefined && res.errors['trial_form_grade.grade'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if ($.isArray(res.errors['trial_form_grade.grade']) ) {
				message = res.errors['trial_form_grade.grade'][0];
			} else {
				message = res.errors['trial_form_grade.grade'];
			}
			$(".grade_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			// 背景を変更する時ラジオボタンの場合は親要素のtdにclass追加
			$("#grade").addClass("trialForm-error");
			confirmButtonDisplay();
		} else {
			// 背景を変更する時ラジオボタンの場合は親要素のtdからclass削除
			$("#grade").removeClass("trialForm-error");
			confirmButtonDisplay();
		}
	});
}

/**
 * 確認ボタンの表示を切り替える
 */
function confirmButtonDisplay() {
	var data = $("form").serializeArray();
	ajaxAllValidate = $.ajax({
		type:'POST',
		url:"/trial/ajax_validate_all/",
		data: { is_json: 1, 'validate_data':data}
	}).done(function( res ) {
		if (res.data != undefined) {
			$("#input-error-count").text(res.dataCount);
			$("#anchor").val(res.scrollVal);
			$("#confirm-go-bt").css('display','none');
			$("#confirm_err-bt").css('display','block');
		} else {
			$("#confirm-go-bt").css('display','block');
			$("#confirm_err-bt").css('display','none');
		}	
	});
}

/**
 * 郵便番号から住所を取得する
 */
function getAddressForPostal(postal) {
	if (postal.length < '7') {
		return;
	}
	
	//ajaxで住所情報取得
	ajaxPostal1 = $.ajax({
		type: "POST",
		url: "/postal/get_data/" + postal,
		data: { is_json: 1}
	}).done(function( res ) {
		if (res.list == false) {
			return;
		}
		// エラー強調解除
		$('#pref_cd').removeClass('trialForm-error');
		$('#s_place_cd').removeClass('trialForm-error');
		$('#address1').removeClass('trialForm-error');
		$('#postal').removeClass('trialForm-error');
		$(".postal_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".pref_cd_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".s_place_cd_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".address1_err").children('p.inq-form-err').each(function() {$(this).remove();});

		// 入力完了マーク
		$('#pref_cd_chk').css('display', 'inline');
		$('#s_place_cd_chk').css('display', 'inline');
		$('#postal_chk').css('display', 'inline');
		
		
		// 都道府県設定
		var prefCd = res.list.City.pref_cd;
		var cityCd = res.list.Postal.s_place_cd;
		$('#pref_cd').val(prefCd);
		// 市区町村設定
		ajaxPostal2 = $.ajax({
			type: "POST",
			url: "/city/get_combo_list_by_pref/" + prefCd,
			data: { is_json: 1}
		}).done(function( res ) {
			$('#s_place_cd option').remove();
			$('#s_place_cd optgroup').remove();
			$('#s_place_cd').append($('<option>').html("市区町村を選択").val(""));
			$('.js_loading_postal').remove();
			for (var i in res.list) {
				$('#s_place_cd').append($('<option label="' + res.list[i].City.s_place_name + '" value="' + res.list[i].City.s_place_cd +'">' + res.list[i].City.s_place_name + '</option>'));
				if (res.list[i].City.s_place_cd == cityCd) {
					$('#s_place_cd').children().last().prop('selected', true);
				}
			}
			//localstrage保存を行うためchangeイベント発火
			$('[name="trial[s_place_cd]"]').trigger('change');
			
		});
		// 町名・番地設定
		$('#address1').val(res.list.Postal.address2);
		$('#address1').focus();
		if ($('#address1').val() != '') {
			$('#address1_chk').css('display', 'inline');
		}
	});
}

/**
 * フォーム値を復元する
 */
function setRestoreFormValue(){
	formData = getLocalStorageFormData('trial');

	var isExistCityData = false;
	if(formData !== null){
		$.each(formData, function(selector, item){
			if(item === '' || $('[name="' + selector + '"]').attr('disabled') == 'disabled') return true;
			
			//ラジオボタン・チェックボックス・市区町村以外はそのまま値を更新
			if($('[name="' + selector + '"]').attr('type') !== 'radio' && $('[name="' + selector + '"]').attr('type') !== 'checkbox' && selector.indexOf('s_place_cd') == -1) {
				$('[name="' + selector + '"]').val(item);
				//変更時にchangeイベントを発火
				$('[name="' + selector + '"]').trigger('change');

			// ラジオボタンの場合はチェックを付ける
			} else if($('[name="' + selector + '"]').attr('type') == 'radio') {
				$('[name="' + selector + '"][value=' + item + ']').attr('checked', true);
				if (selector.indexOf('register_cd') != -1) {
					// 続柄 その他枠の出し分け
					toggleRegisterEtc();
				} else if (selector.indexOf('sex') != -1) {
					// 性別エラー解除
					clearSexError();
				}

			// チェックボックスの場合はチェックを付ける
			} else if($('[name="' + selector + '"]').attr('type') == 'checkbox') {
				// 配列でチェックを入れる
				if (item != undefined && item.constructor == Array) {
					$.each(item, function(key, val){
						$('[name="' + selector + '"][value=' + val + ']').attr('checked', true);
					})
				}
				//変更時にchangeイベントを発火
				$('[name="' + selector + '"]').trigger('change');

			//市区町村の場合（都道府県読み込み後に値を入れる）
			} else if( selector.indexOf('s_place_cd') != -1 ){
				isExistCityData = true;
				//Localstorageから値を入れるのは読み込み一度限りなので発火後イベントは削除
				$('[name="' + selector + '"]').on('change.storageDataApply', function(){
					$(this).val(item);
					//自分のイベント解除
					$(this).off('change.storageDataApply');
					$(this).trigger('change');
					//blurを発火させ未入力アラートを更新
					$('[name="' + selector + '"]').trigger('blur');
				});
			}
		});
		//blurを発火させ未入力アラートを更新（市区町村の値が入っている場合はajax取得後に更新）
		if(isExistCityData == false) {
			$('[name="' + Object.keys(formData).pop() + '"]').trigger('blur');
		}
	}
}

/**
 * 曜日リストの選択可否を切り替える
 */
function toggleDayList(koushaId, boolChecked) {
	// 曜日枠
	const dayListElement = $('.js-days-li[data-kousha-id=' + koushaId + ']');
	// 選択枠
	const inputDayListElement = dayListElement.find('[name^="trial[kousha_info]"][data-always-disabled!="true"]');
	if (!boolChecked) {
		// チェックなしのとき
		// 曜日選択箇所をグレーアウト
		dayListElement.addClass('daysList-off');

		// 曜日選択を全て外す
		inputDayListElement.attr('checked', false);
		inputDayListElement.attr('disabled', true);
	} else {
		// チェックありのとき
		// 曜日選択箇所をグレーアウト
		dayListElement.removeClass('daysList-off');

		// 曜日選択を全て外す
		inputDayListElement.attr('disabled', false);
	}
}

/**
 * 曜日リストのエラー文言を切り替える
 */
function toggleDayListErrorText(koushaId, boolChecked) {
	// チェックが外れた場合に「体験を希望する教室」にチェックが入っていませんのメッセージを表示
	if (!boolChecked) {
		// チェックなしのとき
		$('.js-not-check-kousha-alert[data-kousha-id="' + koushaId + '"]').show();
	} else {
		// チェックありのとき
		$('.js-not-check-kousha-alert[data-kousha-id="' + koushaId + '"]').hide();
	}
}

/**
 * 希望曜日のバリデーションを実行する
 */
function ajaxHopeDayCheck() {
	const data = $("form").serializeArray();
	$.ajax({
		type:'POST',
		url:"/trial/ajax_validate_all/",
		data: { is_json: 1, 'validate_data':data}
	}).done(function( res ) {
		if (res && res.errors && res.errors["trial_ajax_form.hope_day"] && res.errors["trial_ajax_form.hope_day"]["hope_day_kousha"]) {
			// 体験授業希望曜日にエラーがある場合、エラーメッセージ表示
			showErrorHopeDay(res.errors["trial_ajax_form.hope_day"]);

		} else {
			$('.js-error-hope-day').removeClass('trialForm-error');
			$('.hope_day_err').html('');
		}
	});
}

/**
 * 希望曜日のエラーメッセージを表示する
 */
function showErrorHopeDay(hopeDayErrors) {
	// 校舎IDごとにチェック
	const koushaIds = $('input[name="kousha_id[]"]').map((_, el) => el.value).get();
	koushaIds.forEach(koushaId => {
		if (!hopeDayErrors["hope_day_kousha"][koushaId]) {
			$('.js-error-hope-day[kousha_id="' + koushaId + '"]').removeClass('trialForm-error');
			$('.hope_day_err[kousha_id="' + koushaId + '"]').html('');
		} else {
			const errorMsg = hopeDayErrors["hope_day_kousha"][koushaId];
			$('.js-error-hope-day[kousha_id="' + koushaId + '"]').addClass('trialForm-error');
			$('.hope_day_err[kousha_id="' + koushaId + '"]').html('<p class="inq-form-err">' + errorMsg + '</p>');
		}
	});
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
	trialFormAction();
});